import React, { useRef } from "react"
import emailjs from '@emailjs/browser'

import './contact.css'

const Contact = () => { 

  const form = useRef ();
  
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_447jiqr', 'template_u6n9ytf', form.current, 'A-wORWC7eAGTvvjme');

    e.target.reset()
  };

  return (
    <form ref={form} onSubmit={sendEmail}  className="container_footer" id="contact-form" >
      <input className="form-control-name" type="text" placeholder="Name & surname" name="user_name" required/>
      <input className="form-control-email" type="email" placeholder="Email" name="user_email" required/>
      <input className="form-control-asunto my-col-2" type="text" placeholder="Matter" name="user_subject" required/>
      <textarea input className="form-control my-col-2" placeholder="Write a message" rows="8" name="message" required></textarea>
      <input className="btn btn-outline-secondary my-col-2" type="submit" value="Enviar"/>
    </form>
    
 
  );
}



export default Contact;